import React, { useEffect, useState, Fragment } from "react";
import { styled } from '@mui/material/styles';
import { getDispositivi, getCallTypes } from "../../const/CardDati";
import { Grid, Button, TextField, Autocomplete, Checkbox, FormControl, Card, CardContent, IconButton, CardActions, Collapse, Typography } from "@mui/material";
import DateTimePicker from '@mui/lab/DateTimePicker';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './FilterPanelDatatable.module.css';
import { calcPrevMonthDate } from "../../functions/ShortCutDate";
import axios from "axios";


const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));


let today = new Date();
const resultDate = calcPrevMonthDate(today);
const url = process.env.REACT_APP_URL;
const action = getDispositivi.action;
const actionCallType = getCallTypes.action; 


function FilterPanelDatatable({ isFetching, handleFilterData }) {
  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const [startDate, setStartDate] = useState(resultDate.beginDate);
  const [endDate, setEndDate] = useState(resultDate.endDate);
  const [phoneNumber, setPhoneNumber] = useState('');

  const [inputDeviceSelect, setInputDeviceSelect] = useState('');
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [selectOptions, setSelectOptions] = useState([]);
  const loadingState = isSelectOpen && selectOptions.length === 0;

  const [inputCallSelect, setInputCallSelect] = useState('');
  const [selectedCallTypes, setSelectedCallTypes] = useState([]);
  const [isCallSelectOpen, setIsCallSelectOpen] = useState(false);
  const [selectCallOptions, setSelectCallOptions] = useState([]);
  const loadingCallState = isCallSelectOpen && selectCallOptions.length === 0;
  
  // handle input change event
  const handleInputChange = (event, value) => {
    setInputDeviceSelect(value);
  };

  // handle selection
  const handleChange = (event, value) => {
    setSelectedDevice(value);
  };

  const handleInputChangeCallSelect = (event, value) => {
    setInputCallSelect(value);
  };

  const handleChangeCallSelect = (event, value) => {
    setSelectedCallTypes(value);
  };

  const loadOptions = () => {
    (async (a) => {
      const response = await axios(inputDeviceSelect ? url + `${ action +'?filter=' + inputDeviceSelect}` : url + action);
     // const json = await response.json();
      setSelectOptions(response.data.result);
    })();
  };

  const loadCallSelectOptions = () => {
    (async (a) => {
      const response = await axios( url + actionCallType);
      setSelectCallOptions(response.data.result);
    })();
  };

  useEffect(() => {
    let active = true;
    
    if (!loadingState) {
      return undefined;
    }
    
    (async () => {   
      if (active) {
         loadOptions();
      }
    })();

    return () => {
      active = false;
    };

  }, [loadingState]);

  useEffect(() => {
    let active = true;
    
    if (!loadingCallState) {
      return undefined;
    }
    
    (async () => {   
      if (active) {
         loadCallSelectOptions();
      }
    })();

    return () => {
      active = false;
    };

  }, [loadingCallState]);


  return (
    <>
        <Grid container item>
          <Grid item component={Card} xs={12} sm={12} sx={{boxShadow: 0}}>
            <CardActions sx={{justifyContent: 'flex-end'}} disableSpacing>
                <Typography variant="button">{expanded ? 'Riduci' : 'Espandi'} Filtri Avanzati</Typography>
                <ExpandMore
                    expand={expanded}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show more"
                    >
                    <ExpandMoreIcon />
                </ExpandMore>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <CardContent>
                  <Grid container columnSpacing={3} rowSpacing={3}>
                      <Grid item xs={12} sm={4} md={2}>
                          <DateTimePicker
                            label="Dal"
                            value={startDate}
                            onChange={(newDate) => {
                              setStartDate(newDate);
                            }}
                            maxDate={today}
                            renderInput={(params) => <TextField {...params} id="fromDate" variant="standard" size="small" inputProps={{...params.inputProps, placeholder: 'gg/mm/aaaa'}} fullWidth/>}
                          />
                      </Grid>
                      <Grid item xs={12} sm={4} md={2}>
                        <DateTimePicker
                            label="Al"
                            value={endDate}
                            onChange={(newDate) => {
                              setEndDate(newDate);
                            }}
                            maxDate={today}
                            renderInput={(params) => <TextField {...params} id="toDate" variant="standard" size="small" inputProps={{...params.inputProps, placeholder: 'gg/mm/aaaa'}} fullWidth/>}
                          />
                      </Grid>
                      <Grid item xs={12} sm={4} md={2}>
                        <TextField id="phoneNumber"
                                   label="Mittente/Destinatario"
                                   variant="standard"
                                   size="small"
                                   fullWidth
                                   onChange={(event) => {
                                    setPhoneNumber(event.target.value);
                                  }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                          <FormControl fullWidth>
                            <Autocomplete
                              multiple
                              id="devices"
                              size="small"
                              open={isSelectOpen}
                              onOpen={() => {
                                setIsSelectOpen(true);
                              }}
                              onClose={() => {
                                setIsSelectOpen(false);
                              }}
                              loading={loadingState}
                              options={selectOptions}
                              value={selectedDevice}
                              disableCloseOnSelect
                              limitTags={1}
                              getOptionLabel={(option) => option.denominazione}
                              onChange={handleChange}
                              onInputChange={handleInputChange}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.denominazione}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField {...params} label="Dispositivi" variant="standard" InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <Fragment>
                                        {loadingState ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                      </Fragment>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </FormControl> 
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                          <FormControl fullWidth>
                            <Autocomplete
                              multiple
                              id="calltypes"
                              size="small"
                              open={isCallSelectOpen}
                              onOpen={() => {
                                setIsCallSelectOpen(true);
                              }}
                              onClose={() => {
                                setIsCallSelectOpen(false);
                              }}
                              loading={loadingCallState}
                              options={selectCallOptions}
                              value={selectedCallTypes}
                              disableCloseOnSelect
                              limitTags={1}
                              getOptionLabel={(option) => option.descrizione}
                              onChange={handleChangeCallSelect}
                              onInputChange={handleInputChangeCallSelect}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.descrizione}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField {...params} label="Tipologia Chiamata" variant="standard" InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <Fragment>
                                        {loadingCallState ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                      </Fragment>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </FormControl> 
                        </Grid>
                        <Grid container item>
                          <Grid item xs={12} className={styles.buttonGrid}>
                            <Button variant="contained" disabled={isFetching} className={styles.buttonStyle} onClick={() => {
                                handleFilterData(startDate, endDate, phoneNumber, selectedDevice, selectedCallTypes);
                              }}>Applica</Button>
                        </Grid>
                      </Grid>
                  </Grid>
              </CardContent>
              </Collapse>
          </Grid>
        </Grid>
    </>
  );
}

export default FilterPanelDatatable;
